import _classCallCheck from "/tmp/264ea0a6/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/tmp/264ea0a6/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

/**
 * Style
 */
import vars from './replacers/vars';
import mediaQueries from './replacers/media-queries';
import Value from './value';
import utils from './utils';

var _default =
/*#__PURE__*/
function () {
  /**
   * Constructor
   * @param {Object} source plain object style with variables
   * @param {Array} [varsArr] array of vars objects
   */
  function _default(source) {
    var varsArr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    _classCallCheck(this, _default);

    this.source = source;
    this.varsArr = varsArr;
    this.processedSource = null;
    this.extractedVars = null;
    this.extractedProps = null;
    this.calculatedVars = null;
    this.calculatedProps = null;
  }
  /**
   * Calculates style
   * @returns {Object}
   */


  _createClass(_default, [{
    key: "calc",
    value: function calc() {
      this.processSource();
      this.calcVars();
      this.calcProps();
      this.tryOutline();
      return {
        calculatedVars: this.calculatedVars,
        calculatedProps: this.calculatedProps
      };
    }
  }, {
    key: "processSource",
    value: function processSource() {
      this.processedSource = mediaQueries.process(this.source);
    }
  }, {
    key: "calcVars",
    value: function calcVars() {
      this.extractedVars = vars.extract(this.processedSource);

      if (this.extractedVars) {
        var varsArrForVars = [this.extractedVars].concat(this.varsArr);
        this.calculatedVars = calcPlainObject(this.extractedVars, varsArrForVars);
        this.varsArr = [this.calculatedVars].concat(this.varsArr);
      }
    }
  }, {
    key: "calcProps",
    value: function calcProps() {
      this.extractedProps = utils.excludeKeys(this.processedSource, this.extractedVars);
      this.calculatedProps = calcPlainObject(this.extractedProps, this.varsArr);
    }
  }, {
    key: "tryOutline",
    value: function tryOutline() {
      var outline = vars.get('$outline', this.varsArr);

      if (outline) {
        this.calculatedProps.borderWidth = typeof outline === 'number' ? outline : 1;
        this.calculatedProps.borderColor = getRandomColor();
      }
    }
  }]);

  return _default;
}();
/**
 * Calculates values in plain object
 *
 * @param {Object} obj
 * @param {Array} varsArr
 * @returns {Object}
 */


export { _default as default };

function calcPlainObject(obj, varsArr) {
  return Object.keys(obj).reduce(function (res, prop) {
    res[prop] = new Value(obj[prop], prop, varsArr).calc();
    return res;
  }, {});
}
/**
 * Returns random color (needed for outline)
 * @returns {String}
 */


function getRandomColor() {
  var colors = ['black', 'red', 'green', 'blue'];
  var index = Math.round(Math.random() * (colors.length - 1));
  return colors[index];
}